import React from "react";
import { useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars
import { Header, Footer, SystemFeatures } from "isuppli-react-components";

// eslint-disable-next-line no-unused-vars
import { ReduxState } from "../../store/ReduxState";
import menuItems from "../../util/menuItems";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const UserBasicDetails = useSelector((state: ReduxState) => state.userBasicDetails);

  return (
    <div className="d-flex flex-column h-100">
      <Header
        userGreeting={UserBasicDetails?.fullName}
        companyName={UserBasicDetails?.companyName}
        userBadge={UserBasicDetails?.subscriptionName ?? null}
        isAuthenticated
        allowedFeatures={UserBasicDetails?.allowedFeatures ?? SystemFeatures.None}
        menuItems={menuItems}
        onLogout={() => { window.location.href = "/account/logout"; }}
        helpLink="/redirect/helpandsupport"
      />
      <div className="flex-fill">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
